import { useOrganization } from '@foxtrotplatform/platform-micro-site-core';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

interface RequireUserOrgProps {
  children: JSX.Element;
}

export const RequireUserOrg: React.FunctionComponent<
  RequireUserOrgProps & React.HTMLAttributes<HTMLDivElement>
> = ({ children }: RequireUserOrgProps): JSX.Element | null => {
  const navigate = useNavigate();
  const { currentOrg } = useOrganization();
  const [orgExists, setOrgExists] = useState<boolean>(false);

  React.useEffect(() => {
    if (!currentOrg) {
      navigate('/organization');
    } else {
      setOrgExists(true);
    }
  }, [currentOrg]);

  return orgExists ? children : null;
};
